export const getJoinUrl = (
  slug: string,
  origin = window.location.origin,
): string => {
  return new URL(`/cards/${encodeURIComponent(slug)}`, origin).toString();
};
